// src/pages/PrivacyPolicy.jsx
import React from "react";

const PrivacyPolicy = () => {
    return (
        <div className="container py-5">
            <h1 className="mb-4 text-center">Privacy Policy</h1>
            <div className="mb-4">
                <h4>1. Information We Collect</h4>
                <p>
                    We collect personal information such as your name, email address, phone number, and any other details submitted through forms like “Apply Now”, “Call Now”, or “Download Brochure”.
                </p>
            </div>

            <div className="mb-4">
                <h4>2. How We Use Your Information</h4>
                <p>
                    The information you provide is used to contact you regarding admissions, send you brochures or updates, and provide the best educational services possible.
                </p>
            </div>

            <div className="mb-4">
                <h4>3. Sharing of Information</h4>
                <p>
                    We do not sell or rent your data. We may share it with internal teams and trusted third parties solely for processing your application and improving services.
                </p>
            </div>

            <div className="mb-4">
                <h4>4. Cookies and Tracking Technologies</h4>
                <p>
                    We use cookies and analytics tools (like Google Analytics) to enhance user experience and track website usage patterns. You can disable cookies via your browser settings.
                </p>
            </div>

            <div className="mb-4">
                <h4>5. Third-Party Links</h4>
                <p>
                    Our website may include links to third-party websites. We are not responsible for their privacy practices.
                </p>
            </div>

            <div className="mb-4">
                <h4>6. Data Security</h4>
                <p>
                    We take reasonable precautions to protect your information using secure servers and SSL encryption wherever necessary.
                </p>
            </div>

            <div className="mb-4">
                <h4>7. Your Rights</h4>
                <p>
                    You may request access to, correction of, or deletion of your personal data by contacting us.
                </p>
            </div>

            <div className="mb-4">
                <h4>8. Changes to This Policy</h4>
                <p>
                    Arya College may update this Privacy Policy periodically. Any changes will be reflected on this page with the updated effective date.
                </p>
            </div>

            <div className="mb-4">
                <h4>9. Contact Us</h4>
                <p>
                    Arya College<br />
                    SP-40, RIICO Industrial Area, Kukas, Jaipur – 302028<br />
                    Phone: <a href="tel:09001996648">090019-96648</a><br />
                    Email: <a href="mailto:admission@aryacollege.org">admission@aryacollege.org</a>
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
